import {WorkspaceModelType} from "@stores/WorkspaceStore";
import {updateItemChildIdsAdd, updateItemChildIdsRemove} from "./updateItem";
import {updateWorkspaceChildIdsAdd} from "../workspace/updateWorkspace";
import {CrudServices} from "../../platform/services/types/ServiceDependencies";
import {DataSourceManager} from "@stores/dataSources/DataSourceManager";


export const removeFromCluster = (
    services: CrudServices,
    dsManager: DataSourceManager,
    itemId: string,
    targetClusterId: string,
    workspace: WorkspaceModelType
) => {
    const wsUpdateServices = {...services, dsManager};
    const itemMST = workspace.items.get(itemId)!;

    // Compute the parents that will remain after removal (before the async update fires)
    const nonLibraryRemainingParents = itemMST.parentIds
        .filter(id => id !== targetClusterId)
        .filter(id => workspace.items.get(id)?.isLibrary !== true);

    const waitUpdateItems = updateItemChildIdsRemove(services, dsManager, targetClusterId, itemId, workspace);

    let waitUpdateWorkspace: Promise<any> = Promise.resolve();
    if (nonLibraryRemainingParents.length === 0) {
        // No sub-cluster parents remain — restore to the appropriate root
        const libraryId = workspace.findLibraryIdForItem(targetClusterId);
        if (libraryId) {
            // Library-based workspace: put back in the library that owns this cluster
            const libraryItem = workspace.items.get(libraryId)!;
            if (!libraryItem.childIds.includes(itemId)) {
                waitUpdateWorkspace = updateItemChildIdsAdd(services, dsManager, libraryItem, itemMST.id, workspace);
            }
        } else if (!workspace.childIds.includes(itemId)) {
            // Legacy workspace with no libraries: put back at workspace root
            waitUpdateWorkspace = updateWorkspaceChildIdsAdd(wsUpdateServices, workspace, itemMST.id);
        }
    }

    return Promise.all([waitUpdateItems, waitUpdateWorkspace]);
}
